import domReady from '@wordpress/dom-ready';

const searchQuery = () => {
  const findstr = window.findstr || {};
  const searchInput = document.getElementById('main-search_main-search');
  const resultSpan = document.getElementById('result-search-query');
  const noTermSpan = document.getElementById('result-search-no_term');
  const withTermSpan = document.getElementById('result-search-with_term');

  findstr.hooks.addAction(
    'searchResults',
    'displayQueryandCountResults',
    () => {
      if (withTermSpan && noTermSpan) {
        if (searchInput && searchInput.value !== '') {
          noTermSpan.style.display = 'none';
          withTermSpan.style.display = 'inline';
        } else {
          withTermSpan.style.display = 'none';
          noTermSpan.style.display = 'inline';
        }
      }
      if (resultSpan) {
        resultSpan.textContent = searchInput.value;
      }

      //result count
      const field = document.querySelector('.findstr-field-results-count');
      if (field) {
        const resulCount = field.querySelector('.findstr-results-count');

        if (resulCount) {
          // si on a pas de term recherche
          if (searchInput && searchInput.value === '') {
            resulCount.style.display = 'none';
          } else {
            resulCount.style.display = 'inline';
          }
        }
      }
    }
  );

  // Synchronsier avec l'input de recherche
  if (searchInput && resultSpan) {
    searchInput.addEventListener('input', (event) => {
      if (resultSpan) {
        if (withTermSpan) {
          resultSpan.style.display = 'inline';
        } else {
          resultSpan.style.display = 'none';
        }
      }
      resultSpan.textContent = event.target.value;
    });
  }
};

const toggleFiltersButton = () => {
  const filtersButton = document.querySelector(
    '.search-results__filters-button'
  );
  const filtersWrapper = document.querySelector(
    '.search-results__filters-items'
  );

  if (filtersButton && filtersWrapper) {
    filtersButton.addEventListener('click', function () {
      filtersWrapper.classList.toggle('unfolded');
    });
  }
};

const toggleSearchResults = () => {
  const findstrSearchWrappers = document.querySelectorAll(
    '.search-input-wrapper'
  );

  if (0 < findstrSearchWrappers.length) {
    findstrSearchWrappers.forEach((findstrSearchWrapper) => {
      const findstrSearchResults =
        findstrSearchWrapper.querySelector('.findstr-results');
      const findstrSearchInput = findstrSearchWrapper.querySelector(
        'input[type="search"]'
      );

      findstrSearchInput.addEventListener('input', () => {
        if (findstrSearchResults) {
          if ('' === findstrSearchInput.value) {
            findstrSearchResults.classList.remove('findstr-results-visible');
          } else {
            findstrSearchResults.classList.add('findstr-results-visible');
          }
        }
      });

      window.addEventListener('click', (event) => {
        let insiteWrapperClick = false;
        findstrSearchWrappers.forEach((findstrWrapper) => {
          if (findstrWrapper.contains(event.target)) {
            insiteWrapperClick = true;
          }

          if (findstrSearchResults) {
            if (
              !insiteWrapperClick &&
              findstrSearchResults.classList.contains('findstr-results-visible')
            ) {
              findstrSearchResults.classList.remove('findstr-results-visible');
            }
          }
        });
      });
    });
  }
};

domReady(() => {
  searchQuery();
  toggleFiltersButton();
  toggleSearchResults();
});
